import { WebsiteCategoryCookie } from '@/enums/app'
import { Orientations } from '@/enums/products'

export default {
  data () {
    return {
      logoLink: 'index',
      loginLink: 'login',
      accountLink: 'account',
      menuItems: [
        {
          text: 'Navigation.HowDoesItWork',
          nuxtLink: this.$cookies.get(WebsiteCategoryCookie) || 'men',
          hash: '#how-it-works'
        },
        {
          text: 'Navigation.Lookbook',
          nuxtLink: 'lookbook-orientation',
          params: {
            orientation: Orientations.menoriginals
          }
        },
        {
          text: 'Loyalty.Webshop.Links.Webshop',
          nuxtLink: 'webshop',
          hideInNavbar: true,
          params: {}
        },
        {
          text: 'Navigation.FAQ',
          nuxtLink: 'customer-service'
        }
      ]
    }
  },
  computed: {
    navigationMenuItems () {
      return [
        {
          svgPrefix: 'new-home',
          text: this.$t('Account.Navigation.Home'),
          to: {
            path: this.$i18n.localePath({ name: 'account' })
          }
        },
        {
          svgPrefix: 'new-subscription',
          text: this.$t('Account.Navigation.Memberships'),
          to: {
            path: this.$i18n.localePath({ name: 'account-memberships' })
          }
        },
        {
          svgPrefix: 'new-star',
          text: this.$t('Account.Navigation.Loyalty'),
          to: {
            path: this.$i18n.localePath({ name: 'account-loyalty-program' })
          }
        },
        {
          svgPrefix: 'new-orders',
          text: this.$t('Account.Navigation.Orders'),
          to: {
            path: this.$i18n.localePath({ name: 'account-orders' })
          }
        },
        {
          svgPrefix: 'new-settings',
          text: this.$t('Account.Navigation.Settings'),
          to: {
            path: this.$i18n.localePath({ name: 'account-personal-details' })
          }
        }
      ]
    }
  }
}
